"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactLottiePlayer = require("@lottiefiles/react-lottie-player");
require("./LottieAnimation.scss");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const LottieAnimation = _ref => {
  let {
    src,
    style = null,
    autoplay = true,
    loop = true,
    className,
    ratio = null,
    contentfulId
  } = _ref;
  const paddingRatio = (height, width) => {
    if (width && height) {
      if ((height / width * 100).toFixed(2) === 1.00) {
        return "100%";
      }
      // calculate aspect ratio from supplied manual values - for use in Luna components
      return (height / width * 100).toFixed(2).toString() + "%";
    } else {
      // return a default value - 16:9
      return 56.25.toString() + "%";
    }
  };
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "ter-lottie-animation--wrapper",
    style: {
      paddingBottom: paddingRatio(ratio?.height, ratio?.width)
    },
    "data-sb-object-id": contentfulId ? contentfulId : null
  }, /*#__PURE__*/_react.default.createElement(_reactLottiePlayer.Player, {
    autoplay: autoplay,
    loop: loop,
    src: src,
    style: style,
    className: `${className ? className : ''} ter-lottie-animation ${ratio?.width || ratio?.height ? 'ter-lottie-animation--ratio' : ''}`
  }));
};
var _default = LottieAnimation;
exports.default = _default;